














































import {Vue, Component} from 'vue-property-decorator'
import {namespace} from 'vuex-class'

import {
  GetContractPayload,
  GetContractResponse,
} from '@/store/modules/taxrefund/types'

import toCurrency from '@/filters/to-currency'
import toDate from '@/filters/to-date'

import PageFooter from '@/components/PageFooter.vue'

const taxrefund = namespace('taxrefund')
const biz = namespace('biz')

@Component({
  components: {
    PageFooter,
  },
})
export default class CompletedPage extends Vue {
  @biz.State('id') bizId: string | null
  @taxrefund.State('id') taxRefundId: string | null
  @taxrefund.Action('getContract') getContract: (payload: GetContractPayload) => Promise<GetContractResponse>

  refundAmount: string = ''
  contractDate: string = ''
  bankName: string = ''
  bankAccount: string = ''
  confirmedCommission: number = 0

  async mounted() {
    const payload: GetContractPayload = {
      bizId: this.bizId || '',
      taxRefundId: this.taxRefundId || '',
    }
    const res = await this.getContract(payload)
    this.refundAmount = res.expectedRefund
    this.contractDate = res.contractAt
    this.bankName = res.bankName
    this.bankAccount = res.bankAccountNumber
    this.confirmedCommission = res.commissionRate
  }

  AmountToCurrency() {
    return toCurrency(this.refundAmount)
  }
  toDateFormat() {
    const date = new Date(this.contractDate)
    return toDate(date.valueOf())
  }
  getCommissionRateText() {
    const rate = this.confirmedCommission
    return rate ? `${rate * 100}%` : '30%'
  }
}
